export default __webpack_public_path__ + "static/media/home-startup-footer-top-bg.1f7fc97c.jpg";